export const TRANSLATIONS_EN = {
  name: "Yon Frank Trigozo Blacido",

  home: "Home",
  aboutme: "About Me",
  resume: "Resume",
  portfolios: "Portfolio",
  contact: "Contact",

  age: "Age",
  dob: "Date of Birth",
  dobA: "01/17/2002",
  address: "Address",
  addressA: "Peru, Huánuco",
  email: "Email",

  aboutmeTwo: "I am a web designer based in Huánuco, seeking a position as a web designer. I am an organized, responsible, and committed person, graduated from the Juan Bosco Institute of Huánuco, District of Huánuco. Currently, I am learning about user interface design.",
  mySkills: "Skills",
  languages: "Languages",
  español: "Spanish",
  english: "English",
  korean: "Korean",

  resumeTwo: "Resume",
  education: "Education",
  educationYear: "2021 - 2023",
  educationTitle: "Technical Education",
  educationText: "Juan Bosco Institute of Huánuco, Technical career in Information Systems Development",
  educationYearTwo: "2014 - 2018",
  educationTitleTwo: "High School",
  educationTextTwo: "Study Certificate",

  experience: "Experience",
  experienceYear: "2024",
  experienceTitle: "Web Design",
  experienceText: "In 2024, I became interested in web design at the Technical Institute of Tehran and decided to learn it.",
  experienceYearTwo: "2022",
  experienceTitleTwo: "Designer and Photographer",
  experienceTextTwo: "In 2022, I started a six-month pre-professional internship at the Municipal District of Amarilis.",
  experienceYearThree: "2022",
  experienceTitleThree: "UI",
  experienceTextThree: "I recently started learning about this field.",

  contactTwo: "Contact",
  getInTouch: "Get in Touch",
  findMe: "My Location",
  teharnIran: "Huánuco, Peru",
  mailMe: "Email Me",
  emailTwo: "yontrigozoblacido@gmail.com",
  callMe: "Call Me",
  phoneNum: "946-155-005",

  contactForm: "Contact Form",
  nameInp: "Name",
  messageInp: "Message",
  submitBtn: "Submit",

  errorNameOne: "Name is required",
  errorNameTwo: "Name must be longer than two characters",
  errorEmailOne: "Email is required",
  errorEmailTwo: "Invalid email",
  errorMessageOne: "Message is required",
  errorMessageTwo: "Message is too short",

  toastSucc: "Message sent successfully 👍",
  toastErr: "Error sending message ❌",
};